import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router'

export const NOT_FOUND_ROUTE = 'not-found'

/** The parts of an address that the not-found view keeps. */
export type Address = Pick<RouteLocationNormalized, 'path' | 'query' | 'hash'>

/**
 * The not-found view for an address, with the address unchanged in the bar.
 * Used when the API answers 404 for the current page, and when a user opens
 * a page that is hidden from them (MRS 3.1: not-found, never forbidden).
 */
export function notFoundLocation(address: Address): RouteLocationRaw {
  return {
    name: NOT_FOUND_ROUTE,
    params: { pathMatch: address.path.substring(1).split('/') },
    query: address.query,
    hash: address.hash,
  }
}
